export class LengthUnit {
    constructor(scaleFactor) {
        this.scaleFactor = scaleFactor;
    }
    to(unit, value) {
        if (unit.scaleFactor === this.scaleFactor) {
            return value;
        }
        // Convert to primary unit.
        const primaryValue = value / this.scaleFactor;
        // Convert to destination unit.
        return primaryValue * unit.scaleFactor;
    }
}
LengthUnit.Millimeter = new LengthUnit(1000);
LengthUnit.Centimeter = new LengthUnit(100);
LengthUnit.Meter = new LengthUnit(1);
LengthUnit.Kilometer = new LengthUnit(0.001);
LengthUnit.Mile = new LengthUnit(0.0006213712);
//# sourceMappingURL=LengthUnit.js.map